export default function(data) {
var __t, __p = '';
__p += '<div class="badge facebook"></div>\n<div class="badge twitter"></div>\n';
return __p
}